window.XBReviewsAPI = {
  baseUrl: "",

  init(apiUrl) {
    this.baseUrl = String(apiUrl ?? "").replace(/\/$/, "");
  },

  async request(url, options = {}) {
    const response = await fetch(url, options);

    let data;

    try {
      data = await response.json();
    } catch {
      throw new Error(
        `The server returned an invalid response (${response.status}).`
      );
    }

    if (!response.ok) {
      throw new Error(
        data?.message ||
        data?.error ||
        `Request failed with status ${response.status}.`
      );
    }

    return data;
  },

  async getReviews(productId) {
    const safeProductId = String(productId ?? "");

    return this.request(
      `${this.baseUrl}/reviews?product_id=${encodeURIComponent(safeProductId)}`
    );
  },

  async submitReview(payload) {
    return this.request(`${this.baseUrl}/reviews`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload ?? {})
    });
  },

  async helpfulReview(reviewId) {
    const safeReviewId = String(reviewId ?? "");

    return this.request(
      `${this.baseUrl}/reviews/${encodeURIComponent(safeReviewId)}/helpful`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );
  }
};